import {useMutation, useQuery} from "@apollo/react-hooks";
import {makeStyles} from '@material-ui/core/styles';
import React, {useEffect} from 'react';
import {
    CREATE_TEAM_INVITATION,
    DELETE_TEAM_INVITATION,
    GET_TEAM_INVITATIONS,
    SEND_TEAM_INVITATION,
} from "../../../database/queries/teamInvitationQueries";
import MaterialTable from "material-table";
import tableIcons from "../../../constants/tableIcons";
import {SizeMe} from "react-sizeme";
import {notify} from "../../../utils/notify";
import useLayoutStore from "../../../layoutStore";
import {validateEmail} from "../../../utils/utils";
import CalendarStrings from "../../../constants/calendarStrings";
import Moment from "react-moment";
import moment from "moment";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    navigation: {
        marginBottom: 0,
    },
    iFrameNavigation: {
        marginBottom: 0,
        minHeight: 0,
    },
    toolbar: {
        marginBottom: 0
    },
    iFrameToolbar: {
        marginBottom: 0,
        minHeight: 0
    },
    grow: {
        flexGrow: 1,
    },
}));

const TeamInvitations = props => {
    const classes = useStyles();
    const [globalLayoutState] = useLayoutStore();

    const {loading: getTeamInvitationsLoading, error: getTeamInvitationsError, data: getTeamInvitationsData, refetch: getTeamInvitationsRefetch} = useQuery(GET_TEAM_INVITATIONS, {
        skip: !props.editId,
        variables: {
            teamId: props.editId,
            orderList: []
        },
    });

    const [createTeamInvitation, {error: createTeamInvitationError}] = useMutation(CREATE_TEAM_INVITATION);
    const [deleteTeamInvitation, {error: deleteTeamInvitationError}] = useMutation(DELETE_TEAM_INVITATION);
    const [sendTeamInvitation] = useMutation(SEND_TEAM_INVITATION);


    const resendInvitation = (teamInvitationId) => { // need to change to callback
        sendTeamInvitation({
            variables: {teamInvitationId: teamInvitationId}
        }).then(sendTeamInvitationResult => {
            if (sendTeamInvitationResult.data.sendTeamInvitation.returnCode === 0) {
                notify('sendTeamInvitation', 'info', 'Invitation sent');
                getTeamInvitationsRefetch();
            } else {
                notify('sendTeamInvitation', 'error', 'Invitation not sent');
                getTeamInvitationsRefetch();
            }
        }).catch(e => {
            console.trace(e);
        });
    };

    const columns = [
        {title: 'First Name', field: 'invitationFirstName'},
        {title: 'Last Name', field: 'invitationLastName'},
        {title: 'Email', field: 'invitationEmailAddress'},
        {
            title: 'Expires',
            render: r => {
                if (r) {
                    const old = moment(r.invitationExpiresAt).diff(moment(), 'seconds');
                    if (old < 0) {
                        return (<span>Expired</span>)
                    } else {
                        return (
                            <Moment calendar={CalendarStrings}>{r.invitationExpiresAt}</Moment>
                        )
                    }
                }
            },
        },
        {
            title: 'Resend',
            render: r => {
                if (r) {
                    return (<Link onClick={() => {
                        resendInvitation(r.teamInvitationId)
                    }}>Resend invite</Link>)
                }
            },
        },
    ];

    useEffect(() => {
        if (createTeamInvitationError) notify('createTeamInvitationError', 'error', createTeamInvitationError.message);
        if (deleteTeamInvitationError) notify('deleteTeamInvitationError', 'error', deleteTeamInvitationError.message);
        if (getTeamInvitationsError) notify('getTeamInvitationsError', 'error', getTeamInvitationsError.message);
    }, [deleteTeamInvitationError, getTeamInvitationsError, createTeamInvitationError]);

    if (getTeamInvitationsLoading) return <p>Loading ...</p>;
    if (getTeamInvitationsError) return `Error! ${getTeamInvitationsError.message}`;

    return (
        <div className={classes.root}>
            {getTeamInvitationsData && getTeamInvitationsData.teamInvitations && (
                <div>
                    <SizeMe>
                        {({size}) => {
                            let height = size.height;
                            if (!height) height = window.innerHeight;
                            const tableOptions = {
                                maxBodyHeight: height - (globalLayoutState.tabBarHeight + 50),
                                padding: 'dense',
                                header: true,
                                paging: false,
                                showTitle: true,
                                search: true,
                                actionsColumnIndex: -1
                            };

                            return (
                                <MaterialTable
                                    icons={tableIcons}
                                    title="Team Invitations"
                                    columns={columns}
                                    data={getTeamInvitationsData.teamInvitations}
                                    options={tableOptions}
                                    editable={{
                                        onRowAdd: newData =>
                                            new Promise((resolve, reject) => {
                                                setTimeout(() => {
                                                    if (validateEmail(newData.invitationEmailAddress)) {
                                                        let variables = {
                                                            newTeamInvitation: {
                                                                teamId: props.editId,
                                                                invitationFirstName: newData.invitationFirstName,
                                                                invitationLastName: newData.invitationLastName,
                                                                invitationEmailAddress: newData.invitationEmailAddress
                                                            }
                                                        };
                                                        createTeamInvitation({
                                                            variables: variables
                                                        }).then(createResult => {
                                                            getTeamInvitationsRefetch();
                                                            resolve();
                                                        }).catch((e) => {
                                                            reject();
                                                        })
                                                    } else {
                                                        reject();
                                                    }

                                                    resolve()
                                                }, 1000)
                                            }),
                                        onRowDelete: oldData =>
                                            new Promise((resolve, reject) => {
                                                setTimeout(() => {
                                                    deleteTeamInvitation({
                                                        variables: {
                                                            deleteTeamInvitationId: oldData.teamInvitationId,
                                                        }
                                                    }).then(() => {
                                                        getTeamInvitationsRefetch();
                                                        resolve();
                                                    }).catch((e) => {
                                                        reject();
                                                    });
                                                    resolve()
                                                }, 1000)
                                            }),
                                    }}
                                />
                            );
                        }}
                    </SizeMe>
                </div>
            )}
        </div>
    )
};

export default TeamInvitations
